import { z } from "zod";
import { Separator } from "../separator/separator.type";
import { Uppdrag } from "../uppdrag.type";
import { WaterMeasurementPointData } from "../separator/waterMeasurementPointData.type";
import { InspectionFile } from "../fiveYearsInspection/fiveYearsInspection.type";
import type { WaterMeasurementProtocolStatus } from "./waterMeasurementProtocol.helpers";

export enum IsCompiledStatus {
  Yes = "Yes",
  No = "No",
  NotRelevant = "NotRelevant",
}
export const IsCompiledStatusSchema = z.enum(["Yes", "No", "NotRelevant"]);

export enum WaterMeasurementMethod {
  Tidsstyrt = "Tidsstyrt",
  Flodesproportionellt = "Flodesproportionellt",
}
export const WaterMeasurementMethodSchema = z.nativeEnum(
  WaterMeasurementMethod,
);

export function getWaterMeasurementMethodLabel(
  value: WaterMeasurementMethod | null | undefined,
): string {
  switch (value) {
    case WaterMeasurementMethod.Tidsstyrt:
      return "Tidsstyrt";
    case WaterMeasurementMethod.Flodesproportionellt:
      return "Flödesproportionellt";
    default:
      return "";
  }
}

export type WaterMeasurementProtocol = {
  id: number;
  uuid: string;
  companyUuid: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  separatorId: number;
  uppdragId: number;
  rapportNummer: number;
  isMeasurementPerformed: boolean;
  timeOfMeasurementUtc: Date | null;
  isSentToLab: boolean;
  isLabResponded: boolean;
  isCompiled: IsCompiledStatus | null;
  separator: Separator;
  uppdrag: Uppdrag;
  /** Användaren som utförde provet, joinas in av servern i GET */
  user?: { name: string } | null;
  measurementData: WaterMeasurementPointData | null;
  /** Krävs när provlängd är satt och inte Stickprov */
  waterMeasurementMethod: WaterMeasurementMethod | null;
  waterConsumption: string | null;
  washedVehicleCount: string | null;
  sampleLabel: string | null;
  labReportNumber: string | null;
  lastSeparatorEmptyingDate: string | null;
  lastSeparatorEmptyingDateNotRelevant: boolean;
  notes: string | null;
  /** Övriga bilagor (fd. `files`) */
  otherFiles: InspectionFile[];
  /** Labrapporter — minst en krävs för att steg 3 ska vara komplett */
  labFiles: InspectionFile[];
  /** Persisteras av servern, omräknas vid varje skrivning. Kan aldrig sättas av frontend. */
  status: WaterMeasurementProtocolStatus;
  /**
   * Fält som fortfarande blockerar ReportCompiled, i stegordning med backendens
   * fältnamn. Finns bara på GET-/filendpoint-svaren (inte POST/PATCH) —
   * hämta om protokollet efter en mutation för färska värden.
   */
  missingFields?: string[];
};
